import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// Material components
import { Box, Chip, Icon, Typography, useMediaQuery } from '@material-ui/core';

// Styles
import useStyles from '../../../assets/styles/components/cards/landSearchProgramCard/landSearchProgramCardStyle';

// Constants
import { WHITE } from '../../../constants/color-images';

// Components
import Base from '../components/Base';
import LandSearchProgramCardBody from './components/LandSearchProgramCardBody';
import LogoSource from '../../LogoSource/LogoSource';
import PriceAndMembership from '../components/PriceAndMembership';

// Icons
import { ReactComponent as MisCursosFillSVG } from '../../../assets/images/icons/mis-cursos-fill.svg';

// Constants
import { SOURCES } from '../../../constants/sources';
import ItemListProgramCard from '../ItemListProgramCard/ItemListProgramCard';
import { CHIP_CLASSNAME, LEVEL_NAME } from '../../../constants/levels';

const LandSearchProgramCard = ({programId, userId, sourceId, name, backgroundImage, levelId, content, dataDetail, membershipIdList, isLogged, onClick, onClickMixPanelCard, isListItemCard}) => {
    const classes = useStyles();
    const isResponsive = useMediaQuery(theme => theme.breakpoints.down('xs'));

    const handleClickMixPanelCard = (id) => () => {
        if(!!onClickMixPanelCard) onClickMixPanelCard();
        if (!!onClick) onClick({id});
    };

    return (
        <>
            {
                isListItemCard && <ItemListProgramCard programId={programId} userId={userId} sourceId={sourceId} name={name} backgroundImage={backgroundImage} levelId={levelId} content={content} dataDetail={dataDetail} membershipIdList={membershipIdList} isLogged={isLogged} onClick={onClick} onClickMixPanelCard={onClickMixPanelCard} />
            }
            { 
                !isListItemCard && 
                <Base onClick={handleClickMixPanelCard((programId).toString())} isResponsive={isResponsive} className={classes.rootBase} hasClickEvent={!!onClickMixPanelCard || !!onClick}>
                    <LandSearchProgramCardBody backgroundImage={backgroundImage}>
                        <Box className={classes.dataContainer}>
                            <LogoSource sourceId={sourceId} disabledAutoRes color={WHITE} className={classes[`logoCompany${sourceId}`]}/>
                            <Box mt={clsx({"24px": !isResponsive, "13px": (isResponsive && sourceId === SOURCES.UNID), "16px": (isResponsive && sourceId === SOURCES.UERRE)})}>
                                <Icon component={MisCursosFillSVG} className={clsx(classes.misCursosFillSVGIcon)}/>
                            </Box>
                            <Box>
                                <Typography variant='h4' className={clsx('text-gray-100', classes.programName)}>
                                    { levelId === "BA" ? <p style={{margin: 0}}>Bachillerato <br/>Online</p> : name}
                                </Typography>
                            </Box>
                            <Box mt={clsx({"8px": (isResponsive || !isResponsive && sourceId === SOURCES.UERRE), "16px": (!isResponsive && sourceId === SOURCES.UNID)})}>
                                <Chip label={LEVEL_NAME[levelId]} className={clsx("semi-bold", CHIP_CLASSNAME[levelId])} />  
                            </Box>
                        </Box>
                        <Box className={classes.priceAndMembershipContainer}>
                            <PriceAndMembership isResponsive={isResponsive} content={content} isProgram membershipIdList={membershipIdList}/>
                        </Box>
                    </LandSearchProgramCardBody>
                </Base>
            }
        </>
    );
};

LandSearchProgramCard.defaultProps = {
    membershipIdList: [],
    isListItemCard: false,
};

LandSearchProgramCard.propTypes = {
    programId: PropTypes.number.isRequired,
    userId: PropTypes.number,
    sourceId: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    backgroundImage: PropTypes.string.isRequired,
    levelId: PropTypes.string.isRequired,
    content: PropTypes.shape({
        price: PropTypes.shape({
            number: PropTypes.number,
            listNumber: PropTypes.number,
        }),
        showLabel: PropTypes.bool.isRequired,
        showPrice: PropTypes.bool.isRequired,
        labelToShow: PropTypes.string.isRequired,
        typeLabel: PropTypes.number.isRequired,
    }).isRequired,
    dataDetail: PropTypes.shape({
        modalityId: PropTypes.number,
        documentLabel: PropTypes.string,
        subjectLength: PropTypes.number,
        duration: PropTypes.number,
        language: PropTypes.string,
        description: PropTypes.string,
    }),
    membershipIdList: PropTypes.arrayOf(PropTypes.number),
    isLogged: PropTypes.bool,
    onClick: PropTypes.func,
    onClickMixPanelCard: PropTypes.func,
    isListItemCard: PropTypes.bool,
};

export default LandSearchProgramCard;